import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthLayoutComponent } from '@group24ag/flowkit';

@Component({
  selector: 'app-layout-auth',
  imports: [AuthLayoutComponent, NgOptimizedImage, RouterOutlet],
  template: `
    <flk-auth-layout particles>
      <img
        flkAuthLogo="light"
        class="w-full object-contain"
        ngSrc="./assets/images/flowzilla_gr24_branding.svg"
        width="126"
        height="150"
        alt="flowzilla-gorilla"
        priority />
      <img
        flkAuthLogo="dark"
        class="w-full object-contain"
        ngSrc="./assets/images/flowzilla_gr24_branding_invert.svg"
        width="126"
        height="150"
        alt="flowzilla-gorilla"
        priority />

      <router-outlet></router-outlet>
    </flk-auth-layout>
  `,
})
export class LayoutAuthComponent {}
